export class CloudSnapshotsPerVolume {
    'providerVolumeId';
    'snapshotsData';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "providerVolumeId",
            "baseName": "providerVolumeId",
            "type": "string",
            "format": ""
        },
        {
            "name": "snapshotsData",
            "baseName": "snapshotsData",
            "type": "Array<GenericSnapshotData>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CloudSnapshotsPerVolume.attributeTypeMap;
    }
    constructor() {
    }
}
